module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Edit Preferred Vendor","save":"Save"},"no":{"title":"Edit Preferred Vendor","save":"Lagre"}}')
  delete Component.options._Ctor
}
